// Subtle brand mark — uses the official RPLC SVG from the source site.
// Rendered as a white-tinted mark on the dark theme via CSS filter.
export default function Logo({ className = "", height = 26, testId = "brand-logo" }) {
  return (
    <img
      src="/media/brand/rplc-logo.svg"
      alt="RPLC — Rane Pingle Law Chambers"
      height={height}
      style={{ height, width: "auto" }}
      className={`rplc-logo select-none ${className}`}
      data-testid={testId}
      draggable={false}
    />
  );
}
